<div [class.spinner-hidden]="!visible">
	<div class="spinner-back"></div>
	<div class="spinner">
		<!-- <div class="attesa"></div> -->
		<div
			[ngClass]="baseClass"
			class="spinner-sk"
		>
			@for (item of items; track $index) {
				<div [ngClass]="childClass + ($index + 1)"></div>
			}

			@if (baseClass === "word-press-spinner") {
				<span class="inner-circle"></span>
			}
		</div>
	</div>
</div>
